import { getEnv, resolve as resolveEnv } from 'core/utils/env';

const isProduction = getEnv('APP_ENV') === 'production';

export const DOMAIN_SBER_ID = resolveEnv({
  production: 'id.sber.ru',
  '*': 'id-ift.sber.ru',
});

export const UNITY_PAUSE_SSO_COOKIE_MAX_AGE = isProduction
  ? 60 * 60 * 4
  : 30;

export const SDK_URL = `https://${DOMAIN_SBER_ID}/sdk/web/sberid-sdk.production.js`;
/**
 * Хотелось бы именовать куки с префиксом unityid_ или unity_id_,
 * но по историческим причинам backend уже назвал свои куки unity_rid, unity_sid.
 *
 * Чтобы работала консистентность, следуем правилу - именуем куки с префиксом `unity_`.
 */
export const UNITY_PAUSE_SSO_COOKIE_NAME = 'unity_pause_sso';
export const CSS_SELECTOR_FOR_SDK = 'unityIdSdkInit';

export const UNITY_REDIRECT_URI_LS_LEY = 'unity_redirect_uri';

/**
 * Список допустимых имен GET-params для передачи в oidcParams.redirect_uri
 */
export const REDIRECT_URI_GET_WHITE_LIST = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_nooverride',
  'utm_referrer',
  'option1',
  'option2',
  'option3',
];
